interface UserInitialsProps {
  name: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  color?: string; // hex or tailwind class
}

export default function UserInitials({ name, size = 'md', className = '', color }: UserInitialsProps) {
  const getInitials = (name: string): string => {
    if (!name || name.trim() === '') return 'U';
    
    const parts = name.trim().split(' ');
    if (parts.length === 1) {
      return parts[0].charAt(0).toUpperCase();
    }
    
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  };

  const sizeClasses = {
    sm: 'w-6 h-6 text-xs',
    md: 'w-8 h-8 text-sm',
    lg: 'w-10 h-10 text-base'
  };

  const initials = getInitials(name);

  const baseClasses = color
    ? `bg-transparent border border-gray-300 rounded-full flex items-center justify-center font-medium`
    : `bg-blue-600 text-white rounded-full flex items-center justify-center font-medium`;

  return (
    <div
      className={`
        ${sizeClasses[size]}
        ${baseClasses}
        ${className}
      `}
      title={name}
      style={color ? { color } : undefined}
    >
      {initials}
    </div>
  );
} 